import React from "react";

import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import classes from "./Toolbar.module.css";
import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavagationItems";

const toolbar = (props) => (
    <AppBar className={classes.Color}>
        <Toolbar className={classes.Toolbar}>
            <div className={classes.MobileOnly}>
                <IconButton edge="start" color="inherit" aria-label="menu" onClick={props.toggleDrawer}>
                    <MenuIcon fontSize={"large"}/>
                </IconButton>
            </div>
            <div className={classes.Logo}>
                <Logo/>
            </div>
            <div className={classes.DeskTopOnly}>
                <NavigationItems/>
            </div>
        </Toolbar>
    </AppBar>
);

export default toolbar;
